import { render } from "./AccountSettingTeams.vue?vue&type=template&id=350091a3"
import script from "./AccountSettingTeams.vue?vue&type=script&lang=js"
export * from "./AccountSettingTeams.vue?vue&type=script&lang=js"

import "./AccountSettingTeams.vue?vue&type=style&index=0&id=350091a3&lang=scss"
script.render = render

export default script